<template>
  <v-app>
    <v-toolbar>
      <img :src="COMPANY_LOGO" height="40px">
    </v-toolbar>
    <router-view/>
    <v-footer class="justify-center">
      © {{COMPANY_NAME}} {{getCurrentYear()}}
    </v-footer>
  </v-app>
</template>

<script>
  import moment from 'moment'

  export default {
    data: () => {
      return {
        COMPANY_NAME: process.env.COMPANY_NAME,
        COMPANY_LOGO: process.env.COMPANY_LOGO,
        COMPANY_DOCTOR: process.env.COMPANY_DOCTOR,
        COMPANY_COLOR_PRIMARY: process.env.COMPANY_COLOR_PRIMARY,
        COMPANY_COLOR_SECONDARY: process.env.COMPANY_COLOR_SECONDARY
      }
    },
    methods: {
      getCurrentYear () {
        return moment().format('YYYY')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue